import React from 'react';
import PropTypes from 'prop-types';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import NotificationsIcon from '@mui/icons-material/Notifications';

const NotificationBadge = ({ count, onClick }) => {
  return (
    <Box
      role="button"
      onClick={onClick}
      sx={{
        ml: 1,
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
      }}
    >
      <Badge
        badgeContent={count}
        color="secondary"
        overlap="circular"
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{
          '& .MuiBadge-badge': {
            backgroundColor: '#E8A33D',
            color: '#ffffff',
            minWidth: { xs: '1.125rem', xl: '1.4rem' },
            height: { xs: '1.125rem', xl: '1.4rem' },
            px: { xs: '0.3rem', xl: '0.4rem' },
            borderRadius: '50%',
            fontSize: { xs: '0.625rem', xl: '0.75rem' },
            fontWeight: 700,
            boxShadow: '0 0 0 2px #0b0b0b',
          },
        }}
      >
        <Box
          sx={{
            width: { xs: '2.25rem', xl: '2.7rem' },
            height: { xs: '2.25rem', xl: '2.7rem' },
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#1a1a1a',
            color: '#f0f0f0',
            transition: 'background-color 150ms ease-in-out, box-shadow 150ms ease-in-out',
            boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.06)',
            '&:hover': {
              backgroundColor: '#222222',
              boxShadow: '0 0 0 2px rgba(255,255,255,0.1)',
            },
          }}
        >
          <NotificationsIcon sx={{ fontSize: { xs: '1.25rem', xl: '1.4rem' } }} />
        </Box>
      </Badge>
    </Box>
  );
};

NotificationBadge.propTypes = {
  count: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default NotificationBadge;
